// extracted by mini-css-extract-plugin
module.exports = {"MenuIcon":"MenuIcon_MenuIcon__3eGVR","MenuIconWrapper":"MenuIcon_MenuIconWrapper__1LPnv"};